/** Whether the current user may approve this document (maker-checker + role). */
export function canApproveDocument(access, item) {
  if (!access?.can_approve_documents) return false
  const creatorId = item?.created_by_id
  const userId = access?.current_user_id
  if (!creatorId || !userId) return true
  if (Number(creatorId) !== Number(userId)) return true
  const role = access.membership_role || access.access_role
  return role === "admin" || role === "md"
}
